import Modal from 'trunks/vue/admin/components/modals/modal.js'
import { newAlertify } from 'trunks/vue/admin/components/alert.js'

export default Vue.extend({
  components: {
    modal: Modal
  },

  props: {
    namespace: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      default: 'create'
    },
    topOrganization: {
      type: Object,
      default() {
        return { name: '', description: '', founder: null }
      }
    },
    superiors: {
      type: Array,
      default() {
        return []
      }
    },
    onSuccess: {
      type: Function
    }
  },

  data() {
    return {
      form: {
        name: this.topOrganization.name || '',
        description: this.topOrganization.description || '',
        founder_id: this.topOrganization.founder ? this.topOrganization.founder.id : (this.superiors[0] ? this.superiors[0].id : null)
      },
      saving: false,
      errorTip: ''
    }
  },

  computed: {
    title() {
      return this.mode === 'edit' ? '编辑顶级组织' : '创建顶级组织'
    }
  },

  template: `
    <modal :title="title" extendClass="top-organization-modal" ref="modal">
      <div class="modal-body mt-4 mb-4">
        <div class="form-field required" :class="{ 'has-error': errorTip && !form.founder_id }">
          <div class="form-field-head">
            <div class="form-field-title">创建者</div>
          </div>
          <div class="form-field-input-container">
            <div class="form-field-input">
              <select v-model="form.founder_id" class="form-field-value">
                <option v-for="superior in superiors" :key="superior.id" :value="superior.id">{{ superior.name }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="form-field required" :class="{ 'has-error': errorTip && !form.name }">
          <div class="form-field-head">
            <div class="form-field-title">组织名</div>
          </div>
          <div class="form-field-input-container">
            <div class="form-field-input">
              <input v-model.trim="form.name" class="form-field-value" type="text" placeholder="请输入组织名" />
            </div>
          </div>
        </div>

        <div class="form-field">
          <div class="form-field-head">
            <div class="form-field-title">简介</div>
          </div>
          <div class="form-field-input-container">
            <textarea v-model.trim="form.description" class="form-field-value" rows="3" placeholder="请输入简介（可选）"></textarea>
          </div>
        </div>

        <div class="form-error-message" v-if="errorTip">{{ errorTip }}</div>
      </div>

      <div slot="footer" class="modal-footer">
        <button class="outlined btn-default" @click="cancel">取消</button>
        <button @click="save" :disabled="saving">{{ saving ? '保存中...' : '保存' }}</button>
      </div>
    </modal>
  `,

  methods: {
    cancel() {
      this.$refs.modal.close()
    },

    save() {
      if (!this._validate()) return
      this.saving = true

      const payload = { top_organization: this.form }
      const baseUrl = this.namespace.urls.top_organizations
      const isEdit = this.mode === 'edit'
      const url = isEdit ? `${baseUrl}/${this.topOrganization.id}` : baseUrl
      const method = isEdit ? 'patch' : 'post'

      Skylark.Libs.Ajax[method](url, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: payload,
        success: (data) => {
          newAlertify(isEdit ? '编辑成功' : '创建成功', { type: 'success' })
          if (this.onSuccess) this.onSuccess(data, { mode: this.mode })
          this.cancel()
        },
        error: (xhr) => {
          const errors = xhr && xhr.responseJSON && xhr.responseJSON.errors
          this.errorTip = errors ? errors.join('，') : '保存失败，请重试'
          newAlertify(this.errorTip, { type: 'error' })
        },
        complete: () => {
          this.saving = false
        }
      })
    },

    _validate() {
      if (!this.form.name) {
        this.errorTip = '组织名必填'
        return false
      }
      if (!this.form.founder_id) {
        this.errorTip = '请选择创建者'
        return false
      }
      this.errorTip = ''
      return true
    }
  }
})
